<script setup lang="ts">
import { ref, watch } from "vue";

const props = defineProps({
  checked: {
    type: Boolean,
    default: false
  },
  label: {
    type: String,
    default: ""
  }
});

// イベント
const emit = defineEmits<{
  (e: "update:checked", value: boolean): void;
}>();

// 内部状態
const innerChecked = ref(props.checked);
const inputEl = ref<HTMLInputElement | null>(null);

// propsの変更を監視して内部状態を更新
watch(
  () => props.checked,
  newVal => {
    innerChecked.value = newVal;
  }
);

// クリックハンドラ
function handleClick(e: MouseEvent): void {
  innerChecked.value = !innerChecked.value;
  emit("update:checked", innerChecked.value);
}
</script>

<template>
  <div class="custom-checkbox" @click.stop="handleClick">
    <input
      ref="inputEl"
      type="checkbox"
      :checked="innerChecked"
      class="hidden-checkbox"
      @click.stop
    />
    <div class="checkbox-display">
      <div class="checkbox-box" :class="{ checked: innerChecked }">
        <svg
          v-if="innerChecked"
          icon="check"
          class="check-icon"
          width="13"
          height="10"
          viewBox="0 0 13 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.59517 7.7342L11.314 1.01541C11.4297 0.899737 11.567 0.840651 11.726 0.838149C11.8851 0.83566 12.0249 0.894746 12.1456 1.01541C12.2662 1.13605 12.3266 1.27465 12.3266 1.4312C12.3266 1.58775 12.2662 1.72635 12.1456 1.84701L5.08725 8.90532C4.94665 9.04592 4.78263 9.11621 4.59517 9.11621C4.40771 9.11621 4.24368 9.04592 4.10309 8.90532L0.855865 5.65812C0.740197 5.54245 0.683108 5.40509 0.684599 5.24605C0.686102 5.08701 0.747178 4.94716 0.867824 4.82652C0.988483 4.70586 1.12708 4.64553 1.28362 4.64553C1.44018 4.64553 1.57878 4.70586 1.69942 4.82652L4.59517 7.7342Z"
            fill="white"
            stroke="white"
          />
        </svg>
      </div>
      <div class="checkbox-label">
        <slot>{{ label }}</slot>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.custom-checkbox {
  display: inline-block;
  cursor: pointer;

  .hidden-checkbox {
    position: absolute;
    width: 0;
    height: 0;
    opacity: 0;
  }

  .checkbox-display {
    display: flex;
    align-items: center;
  }

  .checkbox-box {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    background-color: white;
    border: 1px solid $mild;
    border-radius: 4px;
    transition: background-color 0.2s ease;

    &.checked {
      background-color: #0088c7;
    }
  }

  .check-icon {
    position: absolute;
    font-weight: 600;
    color: white;
  }

  .checkbox-label {
    margin-left: 8px;
    font-size: 16px;
    font-weight: 600;
    color: #31383f;
  }
}
</style>
